import VueRouter from "vue-router"
import theindex from '../views/index'
import theinfo from '../views/info'
import theindex2 from '../views/index2'
import theinfo2 from '../views/info2'

const router = new VueRouter({
    mode: 'history',
    routes: [
        //配置路由的路径
        {
            path: '/',
            redirect: '/index',
            meta: {
                title: '虎虎心理',
                keepAlive: true
            }
        },
        {
            path: '/index',
            component: theindex,
            meta: {
                title: '虎虎心理',
                keepAlive: true
            }
        },
        {
            path: '/info',
            component: theinfo
        },
        {
            path: '/index2',
            component: theindex2,
            meta: {
                title: '虎虎心理',
                keepAlive: true
            }
        },
        {
            path: '/info2',
            component: theinfo2
        }
    ], scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (from.meta.saveSrollTop) {
                from.meta.savedPosition = document.documentElement.scrollTop || document.body.scrollTop;
            }
            return {x: 0, y: to.meta.savedPosition || 0};
        }
    }

})
export default router;